import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import addNotification from 'react-push-notification';
import { getNotificationsUser, markNotificationRead as markNotificationReadApi } from '../api/Notifications/methods';
import { message } from 'antd';

const WEBSOCKET_URL = 'wss://4mq21t70se.execute-api.us-east-1.amazonaws.com/prod';

class WebSocketService {
  constructor() {
    this.user = null;
    this.websocket = null;
    this.notifications = [];
    this.pagination = {
      "page": 1,
      "limit": 10,
      "totalItems": 0,
      "itemsPerPage": 0
    };
    this.viewedNotifications = [];
    this.observers = [];
    this.methodNotification = 'TOAST';
    this.isWebSocketEnabled = true; // Se cambia esta bandera a true cuando se quiera habilitar la conexión
  }

  addObserver(type, observer) {
    this.observers.push({ type, observer });
  }

  removeObserver(type, observer) {
    const index = this.observers.findIndex(item => item.type === type && item.observer === observer);
    if (index !== -1) {
      this.observers.splice(index, 1);
    }
  }

  notifyObservers() {
    this.observers.forEach((observerItem) => {
      if (observerItem.type === 'numberUnseen') {
        observerItem.observer(this.getNumberUnseenNotifications());
      } else {
        observerItem.observer(this.notifications);
      }
    });
  }

  changeMethodNotification(method) {
    this.methodNotification = method;
  }

  checkNotificationPermission() {
    const permission = Cookies.get('notificationPermission');
    return permission;
  }

  requestNotificationPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        webSocketService.setNotificationPermission(permission);
      }
    });
  };

  setNotificationPermission(permission) {
    Cookies.set('notificationPermission', permission, { expires: 365 });
  }

  connect(user) {
    if (!this.isWebSocketEnabled) {
      console.log('WebSocket connection is disabled');
      return;
    }

    if (!this.websocket) {
      this.user = user.attributes;
      this.websocket = new WebSocket(`${WEBSOCKET_URL}?email=${this.user.email}&nit=${this.user['custom:project']}`);

      this.websocket.onopen = () => {
        this.loadNotifications();
        console.log('Successfully connected to WebSocket');
      };

      this.websocket.onmessage = (event) => {
        const dataNotification = JSON.parse(event.data);
        this.newNotification(dataNotification);
      };

      this.websocket.onclose = () => {
        console.log('Disconnected from WebSocket');
        this.websocket = null;
        if (this.user) {
          this.connect(user);
          console.log('Successfully reconnected to WebSocket');
        }
      };
    }
  }

  clearNotifications() {
    this.notifications = [];
    this.viewedNotifications = [];
    this.notifyObservers();
  }

  disconnect() {
    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }
  }

  async loadNotifications(page = 1, limit = 10) {
    try {
      let response = await getNotificationsUser(this.user.email, this.user['custom:project'], page, limit);
      if (response.status === 200) {
        if (response.data.answer) {
          this.notifications = response.data.notifications;
          this.pagination = response.data.pagination;
          this.viewedNotifications = response.data.viewedNotifications;
        }
      } else {
        message.error('Ha ocurrido un error al cargar las notificaciones');
      }
    } catch (error) {
      message.error('Ha ocurrido un error al cargar las notificaciones');
      console.error('Error loading initial notifications', error);
    };
    this.notifyObservers();
  }

  newNotification(newNotification) {
    this.notifications = [...this.notifications, newNotification];
    this.loadNotifications();
    if (this.methodNotification === 'TOAST') {
      const message = this.truncatedMessage(newNotification.message, 50)
      switch (newNotification.type) {
        case 'success':
          toast.success(message);
          break;
        case 'info':
          toast.info(message);
          break;
        case 'warning':
          toast.warning(message);
          break;
        case 'error':
          toast.error(message);
          break;
      }
    } else if (this.methodNotification === 'WEBPUSH') {
      addNotification({
        title: newNotification.title,
        message: this.truncatedMessage(newNotification.message, 50),
        duration: 5000,
        native: true
      });
    }
    this.notifyObservers();
  }

  truncatedMessage(message, limit) {
    if (message === undefined) {
      return '';
    }
    
    return message.length <= limit
      ? message
      : message.substr(0, limit) + ' ...';
  }  

  getNumberUnseenNotifications = () => {
    return this.pagination.totalItems - this.viewedNotifications.length
  }

  getNumberTotalNotifications = () => {
    return this.pagination.totalItems
  }

  sendNotification(notification) {
    // const notificationR = {
    //   "action": "sendMessage",
    //   "type": "success",
    //   "typeInformation": "System",
    //   "title": "Notificacion de front",
    //   "message": "Esto fue enviado desde el frontend.",
    //   "recipients": [
    //     "ALL"
    //   ]
    // }

    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
      const dataNotification = JSON.stringify(notification)
      console.log(dataNotification);
      this.websocket.send(dataNotification);
    } else {
      console.warn('WebSocket is not connected');
    }
  }

  async markNotificationRead(notificationId) {
    if (!this.viewedNotifications.includes(notificationId)) {
      let response = await markNotificationReadApi(notificationId, this.user.email);
      if (response.data.answer) {
        this.viewedNotifications = [...this.viewedNotifications, notificationId];
      } else {
        console.error("An error occurred while updating the notification");
      }
    }
    this.notifyObservers();
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;